export default {
  headerTitle: 'Coastal Inundation Model Viewer',

  disclaimerText: 'By proceeding to the Inundation Model Viewer you are indicating that you have read and understood the assumptions and background pertaining to the modeling work and flooding data results, as summarized in the prior paragraphs of this website. This data should only be used for its specific intended purpose.',

  defaultScenario: {
    stormType: 'tropical',
    returnPeriodNumber: 100,
    yearNumber: 2030
  },

  stormTypes: {
    thunderstorm: {
      title: 'T-storm',
      buttonIcon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47.97998 48"><defs><style>.cls-1{fill:#418fde;}</style></defs><title>Asset 701</title><g id="Layer_2" data-name="Layer 2"><g id="Icons"><path class="cls-1" d="M38.98,9.01a8.73173,8.73173,0,0,0-3.16.58008l-.01068.00488a11.49,11.49,0,0,0-22.82184,1.75659,5.97663,5.97663,0,0,0-7.9112,6.68994L5.07,18.04A3.81041,3.81041,0,0,0,4.48,18a4.5,4.5,0,0,0,0,9h34.5a9.00311,9.00311,0,0,0,8.83-7.24A9.29694,9.29694,0,0,0,47.98,18,8.99222,8.99222,0,0,0,38.98,9.01Z"/><path class="cls-1" d="M28.48,37H22.18652L25.752,31.29492A1.49994,1.49994,0,1,0,23.208,29.70508l-5,8A1.49972,1.49972,0,0,0,19.48,40h6.29346L22.208,45.70508A1.49994,1.49994,0,1,0,24.752,47.29492l5-8A1.49972,1.49972,0,0,0,28.48,37Z"/></g></g></svg>',
      webmapId: '0529e0c8e5c84542b55aaf95f3498518',
      // amount of rainfall options
      stormDurationText: '(over a period of 6 hours)',
      returnPeriodOptions: [{
        returnPeriodNumber: 2,
        rainfallText: '1.83 in',
        returnPeriodText: '2 year',
        stormSurgeOptions: {
          primaryStormSurge: {
            stormSurgeNumber: false,
            slrYearOptions: [{
              yearNumber: 2030,
              buttonText: '1.3 ft',
              slrText: '2030 SLR',
              layerTitles: [
                'Airmass - Airmass_2yrRP_MHHW_2030SLR',
                'Airmass_2yrRP_MHHW_2030SLR'
              ]
            }, {
              yearNumber: 2070,
              buttonText: '4.3 ft',
              slrText: '2070 SLR',
              layerTitles: [
                'Airmass - Airmass_2yrRP_MHHW_2070SLR',
                'Airmass_2yrRP_MHHW_2070SLR'
              ]
            }]
          },
          // can be either an object defining the other secondary storm surge scenario,
          // or the Boolean `false` if there is only 1 storm surge scenario for this return period
          // here is an example of the former
          alternateStormSurge: false
        }
      }, {
        returnPeriodNumber: 10,
        rainfallText: '3.20 in',
        returnPeriodText: '10 year',
        stormSurgeOptions: {
          primaryStormSurge: {
            stormSurgeNumber: false,
            slrYearOptions: [{
              yearNumber: 2030,
              buttonText: '1.3 ft',
              slrText: '2030 SLR',
              layerTitles: [
                'Airmass - Airmass_10yrRP_MHHW_2030SLR',
                'Airmass_10yrRP_MHHW_2030SLR'
              ]
            }, {
              yearNumber: 2070,
              buttonText: '4.3 ft',
              slrText: '2070 SLR',
              layerTitles: [
                'Airmass - Airmass_10yrRP_MHHW_2070SLR',
                'Airmass_10yrRP_MHHW_2070SLR'
              ]
            }]
          },
          alternateStormSurge: false
        }
      }]
    },
    noreaster: {
      title: 'Nor\'easter',
      buttonIcon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><defs><style>.cls-1{fill:#418fde;}</style></defs><title>Asset 702</title><g id="Layer_2" data-name="Layer 2"><g id="Icons"><path class="cls-1" d="M46,42a8.603,8.603,0,0,0-4.62,1.24,5.22951,5.22951,0,0,1-5.43005,0A8.60316,8.60316,0,0,0,31.33008,42,8.64428,8.64428,0,0,0,26.7,43.24,4.62642,4.62642,0,0,1,24,44a4.63739,4.63739,0,0,1-2.71-.76A8.67344,8.67344,0,0,0,16.65991,42,8.60323,8.60323,0,0,0,12.04,43.24,4.68345,4.68345,0,0,1,9.33,44a4.68375,4.68375,0,0,1-2.71-.76A8.60314,8.60314,0,0,0,2,42a2,2,0,0,0,0,4,4.68375,4.68375,0,0,1,2.71.76A8.603,8.603,0,0,0,9.33,48a8.60331,8.60331,0,0,0,4.62-1.24,4.68352,4.68352,0,0,1,2.7099-.76,4.6607,4.6607,0,0,1,2.71009.76A8.64407,8.64407,0,0,0,24,48a8.632,8.632,0,0,0,4.62-1.24,5.21166,5.21166,0,0,1,5.42,0,9.24531,9.24531,0,0,0,9.25,0A4.66026,4.66026,0,0,1,46,46a2,2,0,0,0,0-4Z"/><path class="cls-1" d="M46,34a8.603,8.603,0,0,0-4.62,1.24,5.22951,5.22951,0,0,1-5.43005,0A8.60316,8.60316,0,0,0,31.33008,34,8.64428,8.64428,0,0,0,26.7,35.24,4.62642,4.62642,0,0,1,24,36a4.63739,4.63739,0,0,1-2.71-.76A8.67344,8.67344,0,0,0,16.65991,34,8.60323,8.60323,0,0,0,12.04,35.24,4.68345,4.68345,0,0,1,9.33,36a4.68375,4.68375,0,0,1-2.71-.76A8.60314,8.60314,0,0,0,2,34a2,2,0,0,0,0,4,4.68375,4.68375,0,0,1,2.71.76A8.603,8.603,0,0,0,9.33,40a8.60331,8.60331,0,0,0,4.62-1.24,4.68352,4.68352,0,0,1,2.7099-.76,4.6607,4.6607,0,0,1,2.71009.76A8.64407,8.64407,0,0,0,24,40a8.632,8.632,0,0,0,4.62-1.24,5.21166,5.21166,0,0,1,5.42,0,9.24531,9.24531,0,0,0,9.25,0A4.66026,4.66026,0,0,1,46,38a2,2,0,0,0,0-4Z"/><path class="cls-1" d="M8,22H36.5a7.51582,7.51582,0,0,0,7.33008-5.9A7.62466,7.62466,0,0,0,44,14.5,7.50272,7.50272,0,0,0,36.5,7a7.37787,7.37787,0,0,0-2.71.51l-.0022.001a9.49713,9.49713,0,0,0-18.784,1.91314A4.99042,4.99042,0,0,0,8,14a4,4,0,0,0,0,8Z"/><path class="cls-1" d="M10.9881,24.51776,7.52362,27.98224a1.76777,1.76777,0,0,0,2.5,2.5l3.46448-3.46448a1.76777,1.76777,0,0,0-2.5-2.5Z"/><path class="cls-1" d="M22.98584,24.51776l-3.4646,3.46448a1.76777,1.76777,0,0,0,2.5,2.5l3.4646-3.46448a1.76777,1.76777,0,0,0-2.5-2.5Z"/><path class="cls-1" d="M34.98218,24.51776l-3.46436,3.46448a1.76777,1.76777,0,0,0,2.5,2.5l3.46436-3.46448a1.76777,1.76777,0,0,0-2.5-2.5Z"/></g></g></svg>',
      webmapId: '5303a44452764b30a8f2cb3b62884fa5',
      // amount of rainfall options
      stormDurationText: '(over a period of 48 hours)',
      returnPeriodOptions: [{
        returnPeriodNumber: 10,
        rainfallText: '5.84 in',
        returnPeriodText: '10 year',
        stormSurgeOptions: {
          primaryStormSurge: {
            stormSurgeNumber: false,
            slrYearOptions: [{
              yearNumber: 2030,
              buttonText: '1.3 ft',
              slrText: '2030 SLR',
              layerTitles: [
                'NoreasterAll - Noreaster_10yrRP_MHHW_2030SLR',
                'Noreaster_10yrRP_MHHW_2030SLR'
              ]
            }, {
              yearNumber: 2070,
              buttonText: '4.3 ft',
              slrText: '2070 SLR',
              layerTitles: [
                'NoreasterAll - Noreaster_10yrRP_MHHW_2070SLR',
                'Noreaster_10yrRP_MHHW_2070SLR'
              ]
            }]
          },
          alternateStormSurge: false
        }
      }, {
        returnPeriodNumber: 50,
        rainfallText: '8.46 in',
        returnPeriodText: '50 year',
        stormSurgeOptions: {
          primaryStormSurge: {
            stormSurgeNumber: false,
            slrYearOptions: [{
              yearNumber: 2030,
              buttonText: '1.3 ft',
              slrText: '2030 SLR',
              layerTitles: [
                'NoreasterAll - Noreaster_50yrRP_MHHW_2030SLR',
                'Noreaster_50yrRP_MHHW_2030SLR'
              ]
            }, {
              yearNumber: 2070,
              buttonText: '4.3 ft',
              slrText: '2070 SLR',
              layerTitles: [
                'NoreasterAll - Noreaster_50yrRP_MHHW_2070SLR',
                'Noreaster_50yrRP_MHHW_2070SLR'
              ]
            }]
          },
          // can be either an object defining the other secondary storm surge scenario,
          // or the Boolean `false` if there is only 1 storm surge scenario for this return period
          // here is an example of the latter
          alternateStormSurge: {
            stormSurgeNumber: 100,
            slrYearOptions: [{
              yearNumber: 2030,
              buttonText: '4.0 ft',
              slrText: '2030 SLR',
              layerTitles: [
                'NoreasterAll - Noreaster_50yrRP_100YrSS_2030SLR',
                'Noreaster_50yrRP_100YrSS_2030SLR'
              ]
            }, {
              yearNumber: 2070,
              buttonText: '7.0 ft',
              slrText: '2070 SLR',
              layerTitles: [
                'NoreasterAll - Noreaster_50yrRP_100YrSS_2070SLR',
                'Noreaster_50yrRP_100YrSS_2070SLR'
              ]
            }]
          }
        }
      }, {
        returnPeriodNumber: 100,
        rainfallText: '9.58 in',
        returnPeriodText: '100 year',
        stormSurgeOptions: {
          primaryStormSurge: {
            stormSurgeNumber: 100,
            slrYearOptions: [{
              yearNumber: 2030,
              buttonText: '4.0 ft',
              slrText: '2030 SLR',
              layerTitles: [
                'NoreasterAll - Noreaster_100yrRP_100YrSS_2030SLR',
                'Noreaster_100yrRP_100YrSS_2030SLR'
              ]
            }, {
              yearNumber: 2070,
              buttonText: '7.0 ft',
              slrText: '2070 SLR',
              layerTitles: [
                'NoreasterAll - Noreaster_100yrRP_100YrSS_2070SLR',
                'Noreaster_100yrRP_100YrSS_2070SLR'
              ]
            }]
          },
          alternateStormSurge: {
            stormSurgeNumber: 500,
            slrYearOptions: [{
              yearNumber: 2030,
              buttonText: '4.7 ft',
              slrText: '2030 SLR',
              layerTitles: [
                'NoreasterAll - Noreaster_100yrRP_500YrSS_2030SLR',
                'Noreaster_100yrRP_500YrSS_2030SLR'
              ]
            }, {
              yearNumber: 2070,
              buttonText: '8.5 ft',
              slrText: '2070 SLR',
              layerTitles: [
                'NoreasterAll - Noreaster_100yrRP_500YrSS_2070SLR',
                'Noreaster_100yrRP_500YrSS_2070SLR'
              ]
            }]
          }
        }
      }]
    },
    tropical: {
      title: 'Tropical',
      buttonIcon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.01906 47.99567"><defs><style>.cls-1{fill:#418fde;}</style></defs><title>Asset 681</title><g id="Layer_2" data-name="Layer 2"><g id="Icons"><path class="cls-1" d="M47.62783,24.27785l-.04-.07a2.97161,2.97161,0,0,0-4.04-1.09l-4.63995,2.68a14.82416,14.82416,0,0,0-1.78-9.07995,1.51788,1.51788,0,0,0-.09-.18l-.03-.04-8.67-15.02a2.95731,2.95731,0,0,0-4.04-1.08l-.07995.04a2.97491,2.97491,0,0,0-1.08,4.04l2.67,4.63a14.88981,14.88981,0,0,0-9.25,1.88l-.11.06-14.97,8.65a2.95725,2.95725,0,0,0-1.08,4.04l.04.07a2.95722,2.95722,0,0,0,4.04,1.08l4.65-2.68a14.919,14.919,0,0,0,1.85,9.19.21221.21221,0,0,0,.03.07l.02.03,8.67,15.02a2.95966,2.95966,0,0,0,4.04,1.08l.08-.04a2.96607,2.96607,0,0,0,1.08-4.04l-2.67-4.63a14.74207,14.74207,0,0,0,8.91-1.7,2.90375,2.90375,0,0,0,.35-.18l.03-.02,15.03-8.67A2.97491,2.97491,0,0,0,47.62783,24.27785Zm-31.4,4.22c-.00995-.01-.00995-.02-.02-.03a8.9961,8.9961,0,0,1,3.24-12.22c.02-.01.05-.03.07-.04s.03-.02.05-.03a9.003,9.003,0,0,1,12.21,3.25c.01.02.03.05.04.07s.02.03.03.05a9.01219,9.01219,0,0,1-3.33,12.25c-.01.01-.02.01-.03.02A9.00068,9.00068,0,0,1,16.22781,28.49783Z"/></g></g></svg>',
      webmapId: 'd808e31594d943769e7a7f2974de79fe',
      // amount of rainfall options
      stormDurationText: '(over a period of 48 hours)',
      returnPeriodOptions: [{
        returnPeriodNumber: 10,
        rainfallText: '5.84 in',
        returnPeriodText: '10 year',
        stormSurgeOptions: {
          primaryStormSurge: {
            stormSurgeNumber: false,
            slrYearOptions: [{
              yearNumber: 2030,
              buttonText: '1.3 ft',
              slrText: '2030 SLR',
              layerTitles: [
                'TropicalAll - Tropical_10yrRP_MHHW_2030SLR',
                'Tropical_10yrRP_MHHW_2030SLR'
              ]
            }, {
              yearNumber: 2070,
              buttonText: '4.3 ft',
              slrText: '2070 SLR',
              layerTitles: [
                'TropicalAll - Tropical_10yrRP_MHHW_2070SLR',
                'Tropical_10yrRP_MHHW_2070SLR'
              ]
            }]
          },
          alternateStormSurge: false
        }
      }, {
        returnPeriodNumber: 100,
        rainfallText: '9.58 in',
        returnPeriodText: '100 year',
        stormSurgeOptions: {
          primaryStormSurge: {
            stormSurgeNumber: 100,
            slrYearOptions: [{
              yearNumber: 2030,
              buttonText: '4.5 ft',
              slrText: '2030 SLR',
              layerTitles: [
                'TropicalAll - Tropical_100yrRP_100YrSS_2030SLR',
                'Tropical_100yrRP_100YrSS_2030SLR'
              ]
            }, {
              yearNumber: 2070,
              buttonText: '7.0 ft',
              slrText: '2070 SLR',
              layerTitles: [
                'TropicalAll - Tropical_100yrRP_100YrSS_2070SLR',
                'Tropical_100yrRP_100YrSS_2070SLR'
              ]
            }]
          },
          alternateStormSurge: false
        }
      }, {
        returnPeriodNumber: 500,
        rainfallText: '13.9 in',
        returnPeriodText: '500 year',
        stormSurgeOptions: {
          primaryStormSurge: {
            stormSurgeNumber: 500,
            slrYearOptions: [{
              yearNumber: 2030,
              buttonText: '7.6 ft',
              slrText: '2030 SLR',
              layerTitles: [
                'TropicalAll - Tropical_500yrRP_500YrSS_2030SLR',
                'Tropical_500yrRP_500YrSS_2030SLR'
              ]
            }, {
              yearNumber: 2070,
              buttonText: '10.5 ft',
              slrText: '2070 SLR',
              layerTitles: [
                'TropicalAll - Tropical_500yrRP_500YrSS_2070SLR',
                'Tropical_500yrRP_500YrSS_2070SLR'
              ]
            }]
          },
          alternateStormSurge: false
        }
      }]
    },
    frontal: {
      title: 'Frontal',
      buttonIcon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><defs><style>.cls-1{fill:#418fde;}</style></defs><title>Asset 706</title><g id="Layer_2" data-name="Layer 2"><g id="Icons"><path class="cls-1" d="M37.5,4A10.51412,10.51412,0,0,0,27,14h.00879c-.00073.0152-.00879.028-.00879.04333V15a2,2,0,0,0,4,0V14a6.50927,6.50927,0,1,1,6.5,7H1.97351A1.97347,1.97347,0,0,0,0,22.97351v.053A1.97347,1.97347,0,0,0,1.97351,25H37.5a10.5,10.5,0,0,0,0-21Z"/><path class="cls-1" d="M1.94031,18H16A9,9,0,1,0,7,9h.00879C7.00806,9.0152,7,9.028,7,9.04333V10a2,2,0,0,0,4,0V9a5,5,0,1,1,5,5H1.94031A1.94028,1.94028,0,0,0,0,15.94031v.11938A1.94028,1.94028,0,0,0,1.94031,18Z"/><path class="cls-1" d="M28,28H2a2,2,0,0,0,0,4H28a6,6,0,1,1-6,6V37a2,2,0,0,0-4,0v.95667c0,.01538.00806.02813.00879.04333H18A10,10,0,1,0,28,28Z"/></g></g></svg>',
      webmapId: '55cb372b3baa45698fbc5fa008cf95ca',
      // amount of rainfall options
      stormDurationText: '(over a period of 72 hours)',
      returnPeriodOptions: [{
        returnPeriodNumber: 50,
        rainfallText: '8.46 in',
        returnPeriodText: '50 year',
        stormSurgeOptions: {
          primaryStormSurge: {
            stormSurgeNumber: false,
            slrYearOptions: [{
              yearNumber: 2030,
              buttonText: '1.3 ft',
              slrText: '2030 SLR',
              layerTitles: [
                'FrontalAll - Frontal_50yrRP_MHHW_2030SLR',
                'Frontal_50yrRP_MHHW_2030SLR'
              ]
            }, {
              yearNumber: 2070,
              buttonText: '4.3 ft',
              slrText: '2070 SLR',
              layerTitles: [
                'FrontalAll - Frontal_50yrRP_MHHW_2070SLR',
                'Frontal_50yrRP_MHHW_2070SLR'
              ]
            }]
          },
          alternateStormSurge: false
        }
      }]
    },
  },

  photos360Layer: {
    title: '360 Photo Locations',
    outFields: ['PopupInfo']
  },

  criticalFacilitiesLayer: {
    title: 'Critical Facilities',
    categories: [
      'School',
      'Health Facility',
      'Police Department',
      'EMS/Fire Station',
      'MBTA Station'
    ],
  },
  esriVersion: '4.16'
};
